import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.VehicleMake.Save.IRequest;
type Response = Api.Core.VehicleMake.Save.IResponse;
type Headers = Api.Core.VehicleMake.Save.IHeaders;
const url = '/api/ProductManagement/VehicleMake';
export default async function vehicleMakeSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
